module.exports = __webpack_public_path__ + "img/tips-device-icon.3bf9981c.svg";